"use client"

import * as CheckboxPrimitive from "@radix-ui/react-checkbox"
import { CheckIcon } from "lucide-react"
import * as React from "react"

import * as styles from "./checkbox.styled"

const Checkbox = React.forwardRef<
  React.ComponentRef<typeof CheckboxPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root> & {
    id: string
  }
>(({ className, id, children, disabled, ...props }, ref) => (
  <div className={styles.wrapper}>
    <label htmlFor={id} className={styles.label(disabled)}>
      <CheckboxPrimitive.Root
        ref={ref}
        className={styles.checkbox(className)}
        id={id}
        disabled={disabled}
        {...props}
      >
        <CheckboxPrimitive.Indicator className={styles.checboxIndicator}>
          <CheckIcon className={styles.checkIcon} />
        </CheckboxPrimitive.Indicator>
      </CheckboxPrimitive.Root>
      <div className={styles.checkboxText}>{children}</div>
    </label>
  </div>
))
Checkbox.displayName = CheckboxPrimitive.Root.displayName

export { Checkbox }
